import IconGear from "assets/img/icon-gear.svg?react"
import IconGearDot from "assets/img/icon-gear-dot.svg?react"

import { FC, ReactNode, useState } from "react"
import { useTranslation } from "react-i18next"

import Button from "components/Button/Button"

interface IViewSettingsProps {
    isDefault: boolean
    children(onClose: () => void): ReactNode
}

const ViewSettings: FC<IViewSettingsProps> = ({
    isDefault,
    children,
}) => {
    const { t } = useTranslation()
    const [showViewSettingsModal, setShowViewSettingsModal] = useState(false)

    return (
        <>
            <Button
                theme="transparent"
                round
                icon={isDefault ? <IconGear /> : <IconGearDot />}
                ariaLabel={t("viewSettings.viewSettings")}
                onClick={() => setShowViewSettingsModal(true)} />
            {showViewSettingsModal &&
                children(() => setShowViewSettingsModal(false)) // view settings modal
            }
        </>
    )
}

export default ViewSettings
